import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import ApiService from '../../../services/apiService';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import { updateDiscount } from '../../../../Redux/actions/cartAction';
import { getCartData, getComboData, getOrderEditData } from '../../../../Redux/selecters';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { updateOrderDiscount } from '../../../../Redux/actions/orderEditAction';

const DiscountModal = ({ closeDiscountModal }) => {
  const [discounts, setDiscounts] = useState([]);
  const [orderType, setOrderType] = useState('');
  const [items, setItems] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [promotion, setPromotion] = useState([]);
  const [manualDiscountActive, setManualDiscountActive] = useState(false);
  const [activeType, setActiveType] = useState('Amount');
  const [manualDiscountValue, setManualDiscountValue] = useState('');
  const [discountId, setDiscountId] = useState();
  const [promotionId, setPromotionId] = useState();

  const data = useSelector(getOrderEditData);
  const cartData = useSelector(getCartData);
  const comboCart = useSelector(getComboData);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    Category: 0,
    voucherCode: '',
  });

  const DiscoutsStatic = [
    { value: 'Category', label: 'Category' },
    { value: 'ItemDiscount', label: 'Item Discount' },
    { value: 'totalDiscount', label: 'Total Order Discount' },
    { value: 'Promotion', label: 'Promotion' },
  ];

  const Category = [
    { value: '1', label: 'Voucher' },
    { value: '2', label: 'Promotion' },
  ];

  useEffect(() => {
    fetchDiscounts();
    fetchPromotion();
  }, []);

  useEffect(() => {
    if (orderType?.value === 'Category') {
      fetchCategories();
      setItems([]);
    } else if (orderType?.value === 'ItemDiscount') {
      if (cartData.length > 0) {
        const mappedItems = cartData.map((item) => ({
          id: getItemId(item),
          itemId: getItemId(item),
          name: getItemName(item),
          menuItemName: getItemName(item),
          categoryId: getItemCategoryId(item),
          category: getItemCategory(item),
        }));
        setItems(mappedItems);
      } else if (data.length > 0) {
        const mappedItems = data.map((item) => ({
          id: getItemId(item),
          itemId: getItemId(item),
          name: getItemName(item),
          menuItemName: getItemName(item),
          categoryId: getItemCategoryId(item),
          category: getItemCategory(item),
        }));
        setItems(mappedItems);
      }
    } else if (orderType?.value === 'Promotion') {
      if (cartData.length > 0) {
        const mappedItems = cartData.map((item) => ({
          id: getItemId(item),
          itemId: getItemId(item),
          name: getItemName(item),
          menuItemName: getItemName(item),
          categoryId: getItemCategoryId(item),
          category: getItemCategory(item),
        }));
        setItems(mappedItems);
      } else if (data.length > 0) {
        const mappedItems = data.map((item) => ({
          id: getItemId(item),
          itemId: getItemId(item),
          name: getItemName(item),
          menuItemName: getItemName(item),
          categoryId: getItemCategoryId(item),
          category: getItemCategory(item),
        }));
        setItems(mappedItems);
      }
    }
  }, [orderType, cartData]);

  // Helper functions to extract data from different item structures
  const getItemId = (item) => {
    return item?.item?.record_Id || item?.item?.recordId || item?.itemData?.id || item?.itemData?.itemId || item?.id;
  };

  const getItemName = (item) => {
    return item?.name || item?.item?.itemName || item?.itemData?.name || item?.itemData?.menuItemName || 'Unknown Item';
  };

  const getItemCategory = (item) => {
    return item?.item?.category || item?.itemData?.category || item?.category || 'Unknown Category';
  };

  const getItemCategoryId = (item) => {
    return item?.item?.categoryId || item?.itemData?.categoryId || item?.categoryId || 0;
  };

  const fetchDiscounts = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_DISCOUNT');
      setDiscounts(res?.data.result || []);
    } catch (error) {
      console.error('Error fetching discounts:', error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCategoryChange = (selectedOption) => {
    setFormData({ ...formData, Category: selectedOption?.value });
  };

  const fetchCategories = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_CATEGORY');
      const allCategories = res.data.result || [];

      const cartCategories = cartData.map((item) => getItemCategory(item)).filter((category) => category && category !== 'Unknown Category');

      const filteredCategories = allCategories.filter((category) => {
        return cartCategories.includes(category.name);
      });

      setCategories(filteredCategories);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const fetchPromotion = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_PROMOTION');
      const allPromotion = res.data.result || [];
      setPromotion(allPromotion);
    } catch (error) {
      console.error('Error fetching promotions:', error);
    }
  };

  const handleOrderType = (selectedType) => {
    setOrderType(selectedType);
    setSelectedCategories([]);
    setManualDiscountValue('');
    setDiscountId(null);
    setPromotionId(null);
  };

  // Enhanced type switching with cleanup
  const handleTypeSwitch = (newType) => {
    setActiveType(newType);
    setManualDiscountValue('');
    setDiscountId(null);
  };

  const handleItemSelection = (itemId) => {
    const updatedSelectedCategories = [...selectedCategories];
    if (updatedSelectedCategories.includes(itemId)) {
      setSelectedCategories(updatedSelectedCategories.filter((id) => id !== itemId));
    } else {
      setSelectedCategories([...updatedSelectedCategories, itemId]);
    }
  };

  const handleCategorySelection = (categoryId) => {
    const updatedSelectedCategories = [...selectedCategories];
    if (updatedSelectedCategories.includes(categoryId)) {
      setSelectedCategories(updatedSelectedCategories.filter((id) => id !== categoryId));
    } else {
      setSelectedCategories([...updatedSelectedCategories, categoryId]);
    }
  };

  const handleManualDiscountItemChange = (selectedItem) => {
    if (activeType === 'Amount') {
      setManualDiscountValue(selectedItem?.value?.amount || selectedItem?.value?.percentage || '');
      setDiscountId(selectedItem?.value?.id);
    } else if (activeType === 'Percentage') {
      setManualDiscountValue(selectedItem?.value?.percentage || '');
      setDiscountId(selectedItem?.value?.id);
    }
  };

  const handleManualDiscountValueChange = (e) => {
    setManualDiscountValue(e.target.value);
  };

  const handleVoucherCode = (selectedItem) => {
    if (activeType === 'Amount') {
      setManualDiscountValue(selectedItem?.value?.discountAmount || '');
      setPromotionId(selectedItem?.value?.promotionID);
    } else if (activeType === 'Percentage') {
      setManualDiscountValue(selectedItem?.value?.discountPercentage || '');
      setPromotionId(selectedItem?.value?.promotionID);
    }
  };

  const handleConfirm = () => {
    if (!manualDiscountValue || manualDiscountValue <= 0) {
      toast.error('Please enter a valid discount value.');
      return;
    }

    if (orderType?.value === 'Category') {
      // Apply discount to selected categories
      const selectedCategoryNames = categories.filter((cat) => selectedCategories.includes(cat.id)).map((cat) => cat.name);

      cartData.forEach((item, index) => {
        const itemCategory = getItemCategory(item);

        if (selectedCategoryNames.includes(itemCategory)) {
          const id = getItemId(item);
          dispatch(updateDiscount(index, id, manualDiscountValue, null, activeType, discountId));
        }
      });
    } else if (orderType?.value === 'ItemDiscount') {
      // 💡 Broken item / specific item scenario

      if (!selectedCategories || selectedCategories.length === 0) {
        toast.error('Please select at least one item to apply discount.');
        return;
      }

      selectedCategories.forEach((selectedItemId) => {
        const itemIndex = cartData.findIndex((item) => getItemId(item) === selectedItemId);

        if (itemIndex !== -1) {
          dispatch(
            updateDiscount(
              itemIndex,
              selectedItemId,
              manualDiscountValue,
              null,
              activeType, // 'Amount' or 'Percentage'
              discountId,
              null,
              false // 👈 always line-level, not order-level
            )
          );
        }
      });
    } else if (orderType?.value === 'totalDiscount') {
      // Apply total order discount
      cartData?.forEach((item, index) => {
        const id = getItemId(item);

        if (activeType === 'Amount') {
          // 👉 Fixed total order amount: apply once on first item, mark as order-level
          if (index === 0) {
            dispatch(
              updateDiscount(
                index,
                id,
                manualDiscountValue, // e.g. 50
                null,
                'Amount',
                discountId,
                null,
                true // 👈 isOrderLevelDiscount = true
              )
            );
          }
        } else {
          // Percentage = logical to apply across items (still scales with total)
          dispatch(
            updateDiscount(
              index,
              id,
              manualDiscountValue,
              null,
              'Percentage',
              discountId,
              null,
              false // 👈 normal per-item percentage
            )
          );
        }
      });
    } else if (orderType?.value === 'Promotion') {
      if (formData?.Category === '1') {
        // Voucher code validation
        if (!formData.voucherCode.trim()) {
          toast.error('Please enter a voucher code.');
          return;
        }

        const selectedPromotionDetails = promotion
          .flatMap((promo) => promo.posPromotionDetails || [])
          .find((detail) => detail.vouchorNo === formData.voucherCode);

        if (!selectedPromotionDetails) {
          toast.error('Invalid voucher code.');
          return;
        }

        const selectedPromotion = promotion.find((promo) => (promo.posPromotionDetails || []).includes(selectedPromotionDetails));

        // Apply voucher discount to first item only
        if (cartData.length > 0) {
          const firstItemId = getItemId(cartData[0]);
          dispatch(
            updateDiscount(0, firstItemId, selectedPromotion?.discountAmount || 0, selectedPromotionDetails, 'Amount', null, selectedPromotion?.promotionID)
          );
        }
      } else if (formData?.Category === '2') {
        // Promotion discount
        cartData?.forEach((item, index) => {
          const id = getItemId(item);

          if (activeType === 'Amount') {
            // For amount discount, apply only to first item
            if (index === 0) {
              dispatch(updateDiscount(index, id, manualDiscountValue, null, activeType, null, promotionId));
            }
          } else {
            // For percentage discount, apply to all items
            dispatch(updateDiscount(index, id, manualDiscountValue, null, activeType, null, promotionId));
          }
        });
      }
    }

    closeDiscountModal();
  };

  const handleUpdateConfirm = () => {
    // Implementation for order edit data would go here
    // Similar logic to handleConfirm but using 'data' instead of 'cartData'
    closeDiscountModal();
  };

  const handleClick = () => {
    if (cartData.length > 0) {
      handleConfirm();
    } else if (data.length > 0) {
      handleUpdateConfirm();
    }
  };

  return (
    <Modal show={true} onHide={closeDiscountModal} centered size="lg" className="enhanced-discount-modal">
      <Modal.Header closeButton className="enhanced-modal-header">
        <Modal.Title className="enhanced-modal-title">
          <span className="discount-icon">💰</span>
          Add Discounts
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="enhanced-modal-body">
        {/* Discount Type Toggle */}
        <div className="discount-type-toggle mb-4">
          <div className={`discount-toggle-btn ${activeType === 'Amount' ? 'active' : ''}`} onClick={() => handleTypeSwitch('Amount')}>
            Amount
          </div>
          <div className={`discount-toggle-btn ${activeType === 'Percentage' ? 'active' : ''}`} onClick={() => handleTypeSwitch('Percentage')}>
            Percentage
          </div>
        </div>

        {/* Discount Options */}
        <div className="discount-options-grid mb-4">
          {DiscoutsStatic.map((item, index) => (
            <div key={index} className={`discount-option-card ${item?.label === orderType?.label ? 'active' : ''}`} onClick={() => handleOrderType(item)}>
              <div className="option-label">{item?.label}</div>
            </div>
          ))}
        </div>

        {/* Content Area */}
        <div className="discount-content">
          {orderType?.value === 'ItemDiscount' && (
            <div className="discount-section">
              <h6 className="section-title">Select Items for Discount:</h6>
              <div className="items-list">
                {items?.length === 0 ? (
                  <div className="empty-state">
                    <span className="empty-icon">📦</span>
                    <p className="empty-text">No items available for discount</p>
                  </div>
                ) : (
                  <div className="checkbox-list">
                    {items?.map((item) => (
                      <div key={item.id || item.itemId} className="checkbox-item">
                        <input
                          className="custom-checkbox"
                          type="checkbox"
                          id={item?.id || item?.itemId}
                          name={item?.name || item?.menuItemName}
                          onChange={() => handleItemSelection(item?.id || item?.itemId)}
                          checked={selectedCategories.includes(item?.id || item?.itemId)}
                        />
                        <label className="checkbox-label" htmlFor={item?.id || item?.itemId}>
                          {item?.name || item?.menuItemName}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Only show dropdown for Percentage type */}
              {activeType === 'Percentage' && (
                <div className="form-group">
                  <label className="form-label">Select Discount</label>
                  <Select
                    onChange={handleManualDiscountItemChange}
                    options={discounts?.map((item, index) => ({ value: item, label: item.name }))}
                    placeholder="Select a discount..."
                    className="custom-select"
                    value={discountId ? discounts.find((d) => d.id === discountId) : null}
                  />
                </div>
              )}

              <div className="form-group">
                <label className="form-label">{activeType === 'Amount' ? 'Discount Amount' : 'Discount Percentage'}</label>
                <input
                  type="number"
                  className="form-control custom-input"
                  value={manualDiscountValue}
                  onChange={handleManualDiscountValueChange}
                  placeholder={`Enter ${activeType.toLowerCase()}`}
                  required
                />
              </div>
            </div>
          )}

          {orderType?.value === 'Category' && (
            <div className="discount-section">
              <h6 className="section-title">Select Categories for Discount:</h6>
              <div className="categories-list">
                {categories?.length === 0 ? (
                  <div className="empty-state">
                    <span className="empty-icon">📂</span>
                    <p className="empty-text">No categories available for discount</p>
                  </div>
                ) : (
                  <div className="checkbox-list">
                    {categories?.map((category) => (
                      <div key={category.id} className="checkbox-item">
                        <input
                          className="custom-checkbox"
                          type="checkbox"
                          id={category.id}
                          name={category.name}
                          onChange={() => handleCategorySelection(category.id)}
                          checked={selectedCategories.includes(category.id)}
                        />
                        <label className="checkbox-label" htmlFor={category.id}>
                          {category.name}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Only show dropdown for Percentage type */}
              {activeType === 'Percentage' && (
                <div className="form-group">
                  <label className="form-label">Select Discount</label>
                  <Select
                    onChange={handleManualDiscountItemChange}
                    options={discounts?.map((item, index) => ({ value: item, label: item.name }))}
                    placeholder="Select a discount..."
                    className="custom-select"
                    value={discountId ? discounts.find((d) => d.id === discountId) : null}
                  />
                </div>
              )}

              <div className="form-group">
                <label className="form-label">{activeType === 'Amount' ? 'Discount Amount' : 'Discount Percentage'}</label>
                <input
                  type="number"
                  className="form-control custom-input"
                  value={manualDiscountValue}
                  onChange={handleManualDiscountValueChange}
                  placeholder={`Enter ${activeType.toLowerCase()}`}
                  required
                />
              </div>
            </div>
          )}

          {orderType?.value === 'totalDiscount' && (
            <div className="discount-section">
              <h6 className="section-title">Total Order Discount:</h6>

              {/* Only show dropdown for Percentage type */}
              {activeType === 'Percentage' && (
                <div className="form-group">
                  <label className="form-label">Select Discount</label>
                  <Select
                    onChange={handleManualDiscountItemChange}
                    options={discounts?.map((item, index) => ({ value: item, label: item?.name }))}
                    placeholder="Select a discount..."
                    className="custom-select"
                    value={discountId ? discounts.find((d) => d.id === discountId) : null}
                  />
                </div>
              )}

              <div className="form-group">
                <label className="form-label">{activeType === 'Amount' ? 'Discount Amount' : 'Discount Percentage'}</label>
                <input
                  type="number"
                  className="form-control custom-input"
                  value={manualDiscountValue}
                  onChange={handleManualDiscountValueChange}
                  placeholder={`Enter ${activeType.toLowerCase()}`}
                  required
                />
              </div>
            </div>
          )}

          {orderType?.value === 'Promotion' && (
            <div className="discount-section">
              <h6 className="section-title">Promotion Settings:</h6>

              <div className="form-group">
                <label className="form-label">Select Promotion Type</label>
                <Select
                  onChange={handleCategoryChange}
                  options={Category}
                  placeholder="Select promotion type..."
                  className="custom-select"
                  value={Category.find((c) => c.value === formData.Category.toString())}
                />
              </div>

              {formData?.Category === '2' && (
                <>
                  <div className="form-group">
                    <label className="form-label">Select Promotion</label>
                    <Select
                      onChange={handleVoucherCode}
                      options={promotion?.map((item, index) => ({ value: item, label: item?.name }))}
                      placeholder="Select a promotion..."
                      className="custom-select"
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">{activeType === 'Amount' ? 'Discount Amount' : 'Discount Percentage'}</label>
                    <input type="text" className="form-control custom-input" value={manualDiscountValue} disabled placeholder="Amount will be auto-filled" />
                  </div>
                </>
              )}

              {formData?.Category === '1' && (
                <div className="form-group">
                  <label className="form-label">Voucher Code</label>
                  <input
                    type="text"
                    className="form-control custom-input"
                    name="voucherCode"
                    value={formData?.voucherCode}
                    onChange={handleInputChange}
                    placeholder="Enter voucher code..."
                    required
                  />
                </div>
              )}
            </div>
          )}

          {!orderType?.value && (
            <div className="empty-state">
              <span className="empty-icon">⚙️</span>
              <p className="empty-text">Please select a discount type to continue</p>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="enhanced-modal-footer">
        <Button variant="outline-secondary" onClick={closeDiscountModal} className="cancel-btn">
          Cancel
        </Button>
        <Button onClick={handleClick} className="save-btn" disabled={!orderType?.value || (!manualDiscountValue && orderType?.value !== 'Promotion')}>
          Apply Discount
        </Button>
      </Modal.Footer>

      <style jsx>{`
        /* Enhanced Modal Styles */
        .enhanced-discount-modal .modal-content {
          border-radius: 15px;
          border: none;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
          max-height: 90vh;
          overflow: hidden;
        }

        .enhanced-modal-header {
          background: linear-gradient(135deg, #6e5199, rgba(110, 81, 153, 0.9));
          color: white;
          border-bottom: none;
          padding: 20px 30px;
        }

        .enhanced-modal-title {
          font-size: 20px;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 0;
          color: white;
        }

        .discount-icon {
          font-size: 24px;
        }

        .enhanced-modal-body {
          padding: 30px;
          max-height: 70vh;
          overflow-y: auto;
        }

        /* Discount Type Toggle */
        .discount-type-toggle {
          display: flex;
          background: #f8f9fa;
          border-radius: 10px;
          padding: 4px;
          gap: 4px;
        }

        .discount-toggle-btn {
          flex: 1;
          padding: 12px 20px;
          text-align: center;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          color: #6b7280;
        }

        .discount-toggle-btn.active {
          background: #6e5199;
          color: white;
          box-shadow: 0 2px 8px rgba(110, 81, 153, 0.3);
        }

        .discount-toggle-btn:hover:not(.active) {
          background: #e5e7eb;
        }

        /* Discount Options Grid */
        .discount-options-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 12px;
        }

        .discount-option-card {
          padding: 16px;
          border: 2px solid #e5e7eb;
          border-radius: 12px;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s ease;
          background: white;
        }

        .discount-option-card:hover {
          border-color: #6e5199;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(110, 81, 153, 0.15);
        }

        .discount-option-card.active {
          border-color: #6e5199;
          background: linear-gradient(135deg, #6e5199, rgba(110, 81, 153, 0.9));
          color: white;
          box-shadow: 0 4px 12px rgba(110, 81, 153, 0.3);
        }

        .option-label {
          font-weight: 600;
          font-size: 14px;
        }

        /* Content Sections */
        .discount-content {
          min-height: 200px;
        }

        .discount-section {
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .section-title {
          color: #374151;
          font-weight: 600;
          margin-bottom: 16px;
          padding-bottom: 8px;
          border-bottom: 2px solid #e5e7eb;
        }

        /* Checkbox Lists */
        .checkbox-list {
          max-height: 200px;
          overflow-y: auto;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 12px;
          margin-bottom: 20px;
        }

        .checkbox-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 8px 0;
          border-bottom: 1px solid #f3f4f6;
        }

        .checkbox-item:last-child {
          border-bottom: none;
        }

        .custom-checkbox {
          width: 20px;
          height: 20px;
          accent-color: #6e5199;
          cursor: pointer;
        }

        .checkbox-label {
          cursor: pointer;
          font-weight: 500;
          color: #374151;
          margin: 0;
        }

        /* Form Groups */
        .form-group {
          margin-bottom: 20px;
        }

        .form-label {
          display: block;
          font-weight: 600;
          color: #374151;
          margin-bottom: 8px;
          font-size: 14px;
        }

        .custom-input {
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          padding: 12px 16px;
          font-size: 14px;
          transition: all 0.2s ease;
          width: 100%;
        }

        .custom-input:focus {
          outline: none;
          border-color: #6e5199;
          box-shadow: 0 0 0 3px rgba(110, 81, 153, 0.1);
        }

        .custom-select .react-select__control {
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          min-height: 48px;
        }

        .custom-select .react-select__control:hover {
          border-color: #6e5199;
        }

        .custom-select .react-select__control--is-focused {
          border-color: #6e5199;
          box-shadow: 0 0 0 3px rgba(110, 81, 153, 0.1);
        }

        /* Empty States */
        .empty-state {
          text-align: center;
          padding: 40px 20px;
          color: #6b7280;
        }

        .empty-icon {
          font-size: 48px;
          display: block;
          margin-bottom: 16px;
          opacity: 0.5;
        }

        .empty-text {
          font-size: 16px;
          font-weight: 500;
          margin: 0;
        }

        /* Modal Footer */
        .enhanced-modal-footer {
          padding: 20px 30px;
          background: #f8f9fa;
          border-top: 1px solid #e5e7eb;
          display: flex;
          gap: 12px;
          justify-content: flex-end;
        }

        .cancel-btn {
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 600;
          border: 2px solid #e5e7eb;
          background: white;
          color: #6b7280;
        }

        .cancel-btn:hover {
          border-color: #d1d5db;
          background: #f9fafb;
        }

        .save-btn {
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 600;
          background: linear-gradient(135deg, #6e5199, rgba(110, 81, 153, 0.9));
          border: 2px solid #6e5199;
          color: white;
        }

        .save-btn:hover:not(:disabled) {
          background: linear-gradient(135deg, rgba(110, 81, 153, 0.9), #6e5199);
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(110, 81, 153, 0.3);
        }

        .save-btn:disabled {
          background: #d1d5db;
          border-color: #d1d5db;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .enhanced-modal-body {
            padding: 20px;
            max-height: 60vh;
          }

          .discount-options-grid {
            grid-template-columns: 1fr 1fr;
            gap: 8px;
          }

          .discount-option-card {
            padding: 12px 8px;
          }

          .option-label {
            font-size: 12px;
          }

          .enhanced-modal-footer {
            padding: 16px 20px;
            flex-direction: column;
          }

          .cancel-btn,
          .save-btn {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </Modal>
  );
};

export default DiscountModal;
